/**
 * @fileoverview POST handler for the "/companies/:company_id/mobile_app_linking_configs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdMobileAppLinkingConfigsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdMobileAppLinkingConfigsProps,
  PostCompaniesCompanyIdMobileAppLinkingConfigsResult,
} from "./types";

export const postCompaniesCompanyIdMobileAppLinkingConfigs = reactQueryMutationAdapter(
  postCompaniesCompanyIdMobileAppLinkingConfigsCacheKeys,
  ({
    companyId,
    name,
  }: PostCompaniesCompanyIdMobileAppLinkingConfigsProps): Promise<PostCompaniesCompanyIdMobileAppLinkingConfigsResult> => {
    return fetch(`/companies/${companyId}/mobile_app_linking_configs`, "POST", { name }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
